import React from 'react';
import '../components/Page/Home.css';
import './AppLoadingShell.css';

const SKELETON_ROWS = 3;
const SKELETON_NAV_ITEMS = 4;

const CookbookSkeletonRows = ({ count = SKELETON_ROWS }) => (
  <div className="home-in-progress__loading recents-grid app-loading-shell__content-pulse" aria-hidden="true">
    {Array.from({ length: count }, (_, i) => (
      <div
        key={`app-loading-shell-sk-${i}`}
        className="deck-item home-in-progress__card--roadmap-row home-in-progress__card--cookbook home-in-progress__skeleton"
      >
        <div className="home-in-progress__roadmap-row-main">
          <div className="home-in-progress__row-leading">
            <div className="home-in-progress__skeleton-icon home-in-progress__skeleton-icon--row" />
            <div className="home-in-progress__skeleton-title home-in-progress__skeleton-title--row" />
          </div>
          <div className="home-in-progress__skeleton-stats home-in-progress__skeleton-stats--row" />
        </div>
      </div>
    ))}
  </div>
);

const HomePanelSkeleton = () => (
  <section className="home-page-primary-tabs-panel app-loading-shell__home-panel" aria-hidden="true">
    <div className="app-loading-shell__tablist">
      <span className="app-loading-shell__tab-pill" />
      <span className="app-loading-shell__tab-pill app-loading-shell__tab-pill--short" />
    </div>
    <span className="app-loading-shell__tagline" />
    <span className="app-loading-shell__review-cta" />
    <CookbookSkeletonRows />
  </section>
);

/**
 * Skeleton loading shell — full app chrome during auth bootstrap.
 */
const AppLoadingShell = ({ inline = false }) => {
  if (inline) {
    return (
      <div
        className="app-loading-shell app-loading-shell--inline"
        role="status"
        aria-busy="true"
        aria-label="Loading"
      >
        <CookbookSkeletonRows count={2} />
      </div>
    );
  }

  return (
    <div className="app app-loading-shell--page" role="status" aria-busy="true" aria-label="Loading">
      <header className="app-header app-loading-shell__header" aria-hidden="true">
        <span className="app-loading-shell__header-brand" />
        <span className="app-loading-shell__header-search" />
        <span className="app-loading-shell__header-avatar" />
      </header>

      <nav className="side-panel visible app-loading-shell__side-nav" aria-hidden="true">
        {Array.from({ length: SKELETON_NAV_ITEMS }, (_, i) => (
          <span key={`app-loading-shell-nav-${i}`} className="app-loading-shell__nav-btn" />
        ))}
      </nav>

      <main className="app-main app-loading-shell__main">
        <div className="home-container">
          <div className="home-manager">
            <HomePanelSkeleton />
          </div>
        </div>
      </main>
    </div>
  );
};

export default AppLoadingShell;
